import {
  Grid,
  freeEditEngine,
  virtualizedGridRenderer,
} from '@integec/grid-tools'
import {
  dateTimeCol,
  intCol,
  numCol,
  strCol,
} from '@integec/grid-tools/lib/cols'
import { Button, Icon, Select, Tabs, Upload, message } from 'antd'
import { getAuthorization, getCredentials } from 'api/pgads'
import { ErrorContext, SpinContext } from 'context'
import { exportData, getApiTargetInfo, rowHeaderRender } from 'core'
import {
  JcTmpErrorTable,
  isErrorContains,
} from 'core/component/JcTmpErrorDialog'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Label,
  Title,
} from 'core/screen-util'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
  solarFileCsvInverterEVentResubmit,
  solarFileCsvInverterPerformacneResubmit,
} from './solarapi'
import { getSystemConfigurationInfo } from '../api/pgads'

const INV_EVENT = 'inverter-event'
const INV_PERF = 'inverter-performance'

const SolarCSVImport = ({ targetInfo }) => {
  const [selType, setSelType] = useState()
  const { setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const [activeKey, setActiveKey] = useState('data')
  const [tmpError, setTmpError] = useState([])
  const [data, setData] = useState([])
  const [fileName, setFileName] = useState('')
  const [editInfo, setEditInfo] = useState(
    freeEditEngine.generateInitialEditInfo()
  )
  const [isAllowed, setIsAllowed] = useState({ event: false, perf: false })

  useEffect(
    _ => {
      getSystemConfigurationInfo(targetInfo).fork(setError, data => {
        const event = data.find(
          d => d.key === 'SOLAR_IMPORT_CSV_INVERTER_EVENT'
        ) || { value: 'NO' }
        const perf = data.find(
          d => d.key === 'SOLAR_IMPORT_CSV_INVERTER_PERFORMANCE'
        ) || { value: 'NO' }
        const val = {
          event: event.value === 'YES',
          perf: perf.value === 'YES',
        }
        if (val.event) {
          setSelType(INV_EVENT)
        } else if (val.perf) {
          setSelType(INV_PERF)
        }
        setIsAllowed(val)
      })
    },
    [targetInfo, setError]
  )

  const fileProps = useCallback(
    _ => {
      const fileProps = {
        name: 'file',
        action: `${targetInfo.baseUrl}/solar-file-creation/importcsv/${selType}`,
        method: 'POST',
        headers: getAuthorization(targetInfo),
        ...getCredentials(targetInfo),
      }
      return fileProps
    },
    [selType, targetInfo]
  )

  const onFileUploadChange = res => {
    setFileName(res.file.name)
    if (res.file.status === 'error') {
      setError(res.file.response)
      setSpinning(false)
    }
    if (res.file.status === 'done') {
      setSpinning(false)
      const { data, error } = res.file.response
      setTmpError(error)
      if (isErrorContains(error)) {
        setActiveKey('error')
        setData(data)
      } else {
        successSet()
      }
    }
  }
  const successSet = _ => {
    setEditInfo(freeEditEngine.generateInitialEditInfo())
    setActiveKey('data')
    setData([])
    message.info('Data Import Succesfully')
  }

  const resubmitData = _ => {
    const modData = freeEditEngine.applyEdits({
      data: data,
      editInfo,
    })
    setSpinning(true)
    const api =
      selType === INV_EVENT
        ? solarFileCsvInverterEVentResubmit
        : solarFileCsvInverterPerformacneResubmit
    api(targetInfo)(modData).fork(setError, res => {
      setSpinning(false)
      const { data, error } = res
      setTmpError(error)
      if (isErrorContains(error)) {
        setActiveKey('error')
        setData(data)
        setEditInfo(freeEditEngine.generateInitialEditInfo())
      } else {
        setEditInfo(freeEditEngine.generateInitialEditInfo())
        setActiveKey('data')
        setData([])
        message.info('Data Import Succesfully')
      }
    })
  }
  const isEditalbe = ({ header }) => {
    if (header.isKey) return false
    return true
  }

  const curHeaders = useCallback(
    width => {
      if (selType === INV_EVENT) return SolarNercEventIoHeaders(width)
      return SolarInverterPerformanceHeaders
    },
    [selType]
  )

  return (
    <div>
      <CriteriaRow>
        <div
          style={{
            display: 'grid',
            gap: 10,
            gridTemplateColumns:
              '250px 150px 300px 200px 150px auto auto 200px',
            width: '100%',
          }}
        >
          <Title>Solar Inverter Import File</Title>
          <Label>Import File :</Label>
          <Select onChange={setSelType} value={selType}>
            {isAllowed.event && (
              <Select.Option key={INV_EVENT} value={INV_EVENT}>
                Inverter Event
              </Select.Option>
            )}
            {isAllowed.perf && (
              <Select.Option key={INV_PERF} value={INV_PERF}>
                Inverter Performance
              </Select.Option>
            )}
          </Select>
          <Upload
            {...fileProps()}
            onChange={data => {
              setSpinning(true)
              onFileUploadChange(data)
            }}
            multiple={false}
            showUploadList={false}
          >
            <Button type="primary">
              <Icon type="upload" /> Click to Upload
            </Button>
          </Upload>
          <Button
            onClick={_ => {
              if (selType === INV_EVENT)
                exportData(
                  new Blob([sampleInverEvent]),
                  'csv',
                  'InverterEventSample.csv'
                )
              else
                exportData(
                  new Blob([sampleInverterPerformance]),
                  'csv',
                  'InverterPerformanceSample.csv'
                )
            }}
            type="link"
          >
            Download Sample File
          </Button>
          <Label>
            <div style={{ display: 'flex', gap: 5 }}>
              <div> Last File Imported :</div> <b>{fileName}</b>
            </div>
          </Label>
          <Filler />
          <Button
            disabled={!isErrorContains(tmpError)}
            type="danger"
            onClick={resubmitData}
            icon="save"
          >
            Re-Submit
          </Button>
        </div>
      </CriteriaRow>
      <FullHeightSizer heightOffset={250}>
        {({ height, width }) => (
          <Content style={{ height: height }}>
            <Tabs
              activeKey={activeKey}
              onChange={activeKey => setActiveKey(activeKey)}
              type="card"
            >
              <Tabs.TabPane tab="Data" key="data" forceRender>
                <div style={{ height }}>
                  <Grid
                    data={data}
                    headers={curHeaders(width - 10)}
                    // altBy={u => u.entityId}
                    altBgColor="#ebebeb"
                    onEditInfoChange={setEditInfo}
                    editInfo={editInfo}
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 10,
                      width: width - 10,
                      headerRowHeight: selType === INV_EVENT ? 30 : 60,
                      //   cellRender: inverterEventDoubleClick,
                    })}
                    //   fuzzyFilter={fuzzyFilter}
                    isEditable={isEditalbe}
                    // onSelectionChange={({ selectedRows }) => {
                    //   setInverterSelected(selectedRows)
                    // }}
                    selectionMode="single"
                    selectionType="cell"
                    editMode="cell"
                  />
                </div>
              </Tabs.TabPane>
              <Tabs.TabPane key="error" tab="Warning/Error" forceRender>
                <div>
                  <JcTmpErrorTable
                    errors={tmpError}
                    scroll={{ y: height - 30 }}
                  />
                </div>
              </Tabs.TabPane>
            </Tabs>
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})
export default connect(mapStateToProps)(SolarCSVImport)

const SolarNercEventIoHeaders = width => {
  const headers = [
    // strCol({ ident: 'recordid', display: 'Recordid', isFiltered: true }),
    // strCol({ ident: 'action', display: 'Action', isFiltered: true }),
    // strCol({ ident: 'entityId', display: 'NCR ID/NERC ID', isKey: true }),
    strCol({
      ident: 'plantId',
      display: 'Plant ID',
      isKey: true,
      width: 200,
      ellipsis: true,
    }),
    strCol({
      ident: 'inverterId',
      display: 'Inverter ID',
      isKey: true,
      width: 200,
      ellipsis: true,
    }),
    strCol({
      ident: 'eventId',
      display: 'Event ID',
      //   isKey: true,
      sortOrder: 'asc',
      width: 200,
      ellipsis: true,
    }),
    // strCol({ ident: 'timeZone', display: 'Time Zone', isKey: true }),
    dateTimeCol({
      ident: 'eventstart',
      display: 'Event Start',
      //   isKey: true,
      sortOrder: 'asc',
      width: 200,

      displayFormat: 'MM/DD/YYYY HH:mm',
      dataFormat: 'MM/DD/YYYY HH:mm',
    }),
    strCol({
      ident: 'eventstartTimeZone',
      display: 'Event Start Zone',
      isFiltered: true,
      sortOrder: 'asc',
    }),
    dateTimeCol({
      ident: 'eventend',
      display: 'Event End',
      isFiltered: true,
      sortOrder: 'asc',
      width: 200,

      displayFormat: 'MM/DD/YYYY HH:mm',
      dataFormat: 'MM/DD/YYYY HH:mm',
    }),
    strCol({
      ident: 'eventendTimeZone',
      display: 'Event End Zone',
      isFiltered: true,
      sortOrder: 'asc',
    }),
    strCol({
      ident: 'eventtype',
      display: 'Event Type',
      isFiltered: true,
      sortOrder: 'asc',
    }),
    intCol({
      ident: 'causecode',
      display: 'Causecode',
      isFiltered: true,
      sortOrder: 'asc',
    }),
    strCol({
      ident: 'contributingCondition',
      display: 'Contributing Operating Condition',
      isFiltered: true,
      // ...toSelectionColProps(conMap),
      alignment: 'left',
      width: 200,
      ellipsis: true,
    }),
  ]
  const lastHeaders = [
    // numCol({
    //   ident: 'potentialLoss',
    //   display: 'Potential Generation Loss (MWh)',
    //   isFiltered: true,
    //   width: 200,
    // }),
  ]

  const getWidth = hd => hd.map(h => h.width || 100).reduce((a, b) => a + b, 0)

  let descwidth = width - getWidth(headers) - getWidth(lastHeaders) - 20
  if (descwidth < 0) descwidth = 150
  const desc = strCol({
    ident: 'description',
    display: 'Event Description',
    isFiltered: true,
    width: descwidth,
    ellipsis: true,
    alignment: 'left',
  })
  return [...headers, desc, ...lastHeaders]
}

export const SolarInverterPerformanceHeaders = [
  //   strCol({
  //     ident: 'entityId',
  //     display: 'NCR ID/NERC ID',
  //     isKey: true,
  //     sortOrder: 'asc',
  //     width: 200,
  //   }),
  strCol({
    ident: 'plantId',
    display: 'Plant ID',
    isKey: true,
    sortOrder: 'asc',
    width: 200,
  }),
  strCol({
    ident: 'inverterId',
    display: 'Inverter Id',
    isKey: true,
    sortOrder: 'asc',
    width: 200,
  }),
  intCol({ ident: 'year', display: 'Year', isKey: true, sortOrder: 'asc' }),
  intCol({ ident: 'month', display: 'Month', isKey: true, sortOrder: 'asc' }),
  strCol({
    ident: 'inverterAvailability',
    display: 'Inverter Availability',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'grossactgen',
    display: 'Gross Actual Generation (MWh)',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'netactgen',
    display: 'Net Actual Generation (MWh)',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'netmaxcap',
    display: 'Net Max Capacity (MW)',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'monthlyPoa',
    display: 'Monthly Plane of Array (MWh/m^2)',
    isFiltered: true,
    width: 200,
  }),
  numCol({
    ident: 'performanceRatio',
    display: 'Performance Ratio',
    isFiltered: true,
  }),
  numCol({
    ident: 'expectedGen',
    display: 'Expected Generation',
    isFiltered: true,
  }),
  numCol({
    ident: 'activeSolarIh',
    display: 'Active Solar IHrs (Day)',
    isFiltered: true,
  }),
  numCol({ ident: 'activeIh', display: 'Active IHrs', isFiltered: true }),
  numCol({
    ident: 'inactiveReserveIh',
    display: 'Inactive Reserve IHrs',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'mothballedIh',
    display: 'Mothballed IHrs',
    isFiltered: true,
  }),
  numCol({ ident: 'retiredIh', display: 'Retired IHrs', isFiltered: true }),
  numCol({
    ident: 'serviceIhDay',
    display: 'Service IHrs (Day)',
    isFiltered: true,
  }),
  numCol({
    ident: 'rsIh',
    display: 'Reserve Shutdown IHrs',
    isFiltered: true,
    width: 150,
  }),
  numCol({ ident: 'foIhDay', display: 'Forced IHrs (Day)', isFiltered: true }),
  numCol({
    ident: 'moIhDay',
    display: 'Maintenance IHrs (Day)',
    isFiltered: true,
  }),
  numCol({ ident: 'poIhDay', display: 'Planned IHrs (Day)', isFiltered: true }),
  numCol({
    ident: 'resourceUnaIhDay',
    display: 'Resource Unavailable IHrs (Day)',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'serviceIhNight',
    display: 'Service IHrs (Night)',
    isFiltered: true,
  }),
  numCol({
    ident: 'foIhNight',
    display: 'Forced IHrs (Night)',
    isFiltered: true,
  }),
  numCol({
    ident: 'moIhNight',
    display: 'Maintenance IHrs (Night)',
    isFiltered: true,
  }),
  numCol({
    ident: 'poIhNight',
    display: 'Planned IHrs (Night)',
    isFiltered: true,
  }),
  numCol({
    ident: 'resourceUnaIhNight',
    display: 'Resource Unavailable IHrs (Night)',
    isFiltered: true,
    width: 200,
  }),
]

const sampleInverEvent =
  'PlantId,InverterId,EventId,EventStart,EventStartTimeZone,EventEnd,EventEndTimeZone,EventType,CauseCode,ContribCondition,Description\r\n' +
  'PLN,INV 00,0001,01/01/2024 00:00,EST,01/03/2024 15:30,EST,FO,26600,A,Solar Import'

const sampleInverterPerformance =
  'EntitiyId,PlantId,InverterId,Year,Month,InverterAvailability,GrossActGen,NetActGen,NetMaxCap,MonthlyPOA,PerformanceRatio,ExpectedGen,ActiveSolarIH,ActiveIH,INActiveReserveIH,MothballedIH,RetiredIH,ServiceIHDay,RSIH,FOIHDay,MOIHDay,POIHDay,ResourceUnaIHDay,ServiceIHNight,FOIHNight,MOIHNight,POIHNight,ResourceUnaIHNight\r\n' +
  'ENT1,PLN,INV 00,2024,6,AC,160.2,145.74,3.36,0,0,231.27,440.24,720,0,0,0,79.58,0,0,0,0,360.66,3.99,0,0,0,275.77'
